import { render, staticRenderFns } from "./x-close.vue?vue&type=template&id=9eccd7b4&scoped=true&"
import script from "./x-close.vue?vue&type=script&lang=js&"
export * from "./x-close.vue?vue&type=script&lang=js&"
import style0 from "./x-close.vue?vue&type=style&index=0&id=9eccd7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eccd7b4",
  null
  
)

export default component.exports